import React, { useState } from "react";
import { Card, Accordion } from "react-bootstrap";
import RichText from "components/rich-text";
import {
  pdpOurPromise, opCard, opList, opCBody,
  opCardBody, opContent, opLink, hayaImage, toggleHeader, accordionTitle, accordionIcon,
  accordionIconOpen, accordionBody, opTitle, prodHighlights
} from "./style.mod.scss";
import Modal from "components/customer-service-modals";
import asHTML from "helpers/as-html";
import Image from "components/image";
import Haya from "assets/images/Haya.webp";
import { ChevronDown } from "react-bootstrap-icons";
import locale from "locales";

const PdpOurPromise = ({ variant, handle, color, enhancedPDP, productHighlights }) => {
  const productInfo = variant?.productInfo;
  const miniDescription = productInfo?.miniDescription;
  const [open, setOpen] = useState(1);

  const NeniImage = () => { //Urgent neni image in neni products.
    return (<div className={hayaImage} >
      <img style={{ width: "100%" }} src={Haya} alt={locale.altText.hayaImage} />
      <Accordion.Toggle
        as={Card.Header}
        eventKey={open}
        className={toggleHeader}
        onClick={() => setOpen(open === 1 ? null : 1)}
      >

        <p className={accordionTitle}>Mehr Infos</p>
        <span className={`${accordionIcon} ${1 !== open ? accordionIconOpen : ""}`}>
          <ChevronDown />
        </span>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={open}>
        <Card.Body className={accordionBody}>
          <p>
            Zu jeder Einzelpfanne und jedem Pfannenset in der Olav X NENI Edition erhältst du die <strong>exklusive Olav x NENI Schürze und eine Einladung zu einem Live Kochabend mit Haya Molcho</strong> - das perfekte Geschenk für deine Liebsten!<br /><br /><strong>Zum Kochkurs</strong><br />Wir senden dir Rezept und Zoom Link per Email zu, wenn es soweit ist. Wir freuen uns riesig, bald mit dir zu kochen!<br /> <br />  <strong>Zur Olav x NENI Schürze</strong> <br />Gemeinsam mit Haya haben wir die exklusive Kochschürze designed. Sie besteht zu 100% aus kräftiger Baumwolle, ist handbestickt und passt dank verstellbarem Halsriemen Groß und Klein.
          </p>
        </Card.Body>
      </Accordion.Collapse>
    </div>);
  };

  return (
    <div className={pdpOurPromise}>
      {
        handle.includes("neni") ? <NeniImage /> : ""
      }
      {(!enhancedPDP &&
        miniDescription) && (
        <div className={opList}
        >
          <RichText blocks={miniDescription} />
        </div>
      )
      }
      {
        productHighlights && productHighlights.length !== 0 && (
          <Card className={opCard} style={{ backgroundColor: color && color?.hex }}>
            {!productHighlights?.length > 3 &&
              <p className={opTitle}> {locale.products.iconsMoreInfo} </p>}
            <Card.Body className={enhancedPDP ? `${opCBody} ${opCardBody}` : opCardBody}>
              {
                productHighlights.map((_highlt, index) => (

                  <div key={index} className={productHighlights?.length > 3 ? `${prodHighlights} ${opContent}` : opContent} >
                    <a className={opLink}>
                      <Modal data={_highlt}>
                        <Image image={_highlt?.icon} alt={_highlt?.icon?.alt} />
                        <p>{asHTML(_highlt.text)}</p>
                      </Modal>
                    </a>
                  </div>

                ))
              }
            </Card.Body>
          </Card>
        )
      }
    </div>
  );
};

export default PdpOurPromise;
